var _jsxFileName = "/repo/packages/webassets/src/components/SeatRequestModal/PendingModalContent.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Modal } from '@wds/modal';
import { T, t, FormattedDateTime } from '@sm/intl';
import CancelSeatRequestMutation from './graphql/CancelSeatRequest.graphql';
import RemindSeatRequestMutation from './graphql/RemindSeatRequest.graphql';
import COPY from './SeatRequestCopy';
import { STATUS } from './constants';
var PendingModalContent = function PendingModalContent(_ref) {
  var onModalFinished = _ref.onModalFinished,
    seatRequest = _ref.seatRequest,
    team = _ref.team;
  var _useMutation = useMutation(CancelSeatRequestMutation, {
      onError: function onError() {
        onModalFinished({
          status: STATUS.FAILURE,
          message: t(COPY.TOAST_ERROR)
        });
      },
      onCompleted: function onCompleted() {
        onModalFinished({
          status: STATUS.SUCCESS,
          message: t(COPY.TOAST_REQUEST_CANCELED)
        });
      }
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    cancelSeatRequest = _useMutation2[0],
    cancelLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(RemindSeatRequestMutation, {
      onError: function onError() {
        onModalFinished({
          status: STATUS.FAILURE,
          message: t(COPY.TOAST_ERROR)
        });
      },
      onCompleted: function onCompleted() {
        onModalFinished({
          status: STATUS.SUCCESS,
          message: t(COPY.TOAST_REMINDER_SENT)
        });
      }
    }),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    remindSeatRequest = _useMutation4[0],
    remindLoading = _useMutation4[1].loading;
  var _team$accountOwner = team.accountOwner,
    _email = _team$accountOwner.email,
    firstName = _team$accountOwner.firstName,
    lastName = _team$accountOwner.lastName;
  var emailLabel = firstName ? "".concat(firstName).concat(lastName ? "\xA0".concat(lastName) : '') : _email;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
    header: /*#__PURE__*/React.createElement(T, {
      desc: COPY.MODAL_TITLE_PENDING,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 29
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.PENDING_DESC_1,
    values: {
      date: FormattedDateTime({
        date: new Date(seatRequest.request.date)
      })
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.PENDING_DESC_2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.PENDING_DESC_3,
    values: {
      email: function email() {
        return /*#__PURE__*/React.createElement("a", {
          href: "mailto:".concat(_email),
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 28
          }
        }, emailLabel);
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Modal.Footer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    display: "flex",
    flexJustify: "space-between",
    flexItemGrow: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    color: "warning",
    onClick: cancelSeatRequest,
    disabled: remindLoading || cancelLoading,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CANCEL_REQUEST_BUTTON,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: remindSeatRequest,
    color: "secondary",
    disabled: remindLoading || cancelLoading,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.SEND_REMINDER_BUTTON,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 15
    }
  })), "\xA0", /*#__PURE__*/React.createElement(Button, {
    onClick: onModalFinished,
    disabled: remindLoading || cancelLoading,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CLOSE_BUTTON,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 15
    }
  }))))));
};
PendingModalContent.propTypes = {
  onModalFinished: PropTypes.func.isRequired,
  seatRequest: PropTypes.shape({
    request: PropTypes.shape({
      date: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  team: PropTypes.shape({
    accountOwner: PropTypes.shape({
      email: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }).isRequired
  }).isRequired
};
export default PendingModalContent;
//# sourceMappingURL=PendingModalContent.js.map